// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionWelcome_wrapper__tXaCb","title":"SectionWelcome_title__zP5+j","info":"SectionWelcome_info__dVETR"};